import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

export interface ComplianceStatusFilterData {
  status: '' | 'compliant' | 'non-compliant' | 'pending';
  category:
    | ''
    | 'Financial Controls'
    | 'Data Protection'
    | 'Access Management'
    | 'Audit Logging'
    | 'Enforcement Procedures'
    | 'Dispute Resolution';
  severity: '' | 'sev1' | 'sev2' | 'sev3';
}

@Component({
  selector: 'app-compliance-status-filter-modal',
  templateUrl: './compliance-status-filter-modal.component.html',
  styleUrls: ['./compliance-status-filter-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonRadioGroup,
    IonRadio,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
  ],
})
export class ComplianceStatusFilterModalComponent implements OnInit {
  private modalCtrl: ModalController = inject(ModalController);
  @Input() filters?: Partial<ComplianceStatusFilterData> | null;

  public status: ComplianceStatusFilterData['status'] = '';
  public category: ComplianceStatusFilterData['category'] = '';
  public severity: ComplianceStatusFilterData['severity'] = '';

  ngOnInit() {
    if (!this.filters) return;
    this.status = this.filters.status || '';
    this.category = this.filters.category || '';
    this.severity = this.filters.severity || '';
  }

  applyFilters() {
    this.modalCtrl.dismiss({
      filters: {
        status: this.status,
        category: this.category,
        severity: this.severity,
      },
    });
  }

  clearFilters() {
    this.modalCtrl.dismiss({ clear: true });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
